import Masterconfig from './Masterconfig.js'

const Configuration = {
  install (Vue, options) {
    Vue.mixin({
      created: function () {
        this.masterconfig = new Masterconfig()
      },
      methods: {
        getBaseUrl: function () {
          return this.masterconfig.getBaseUrl()
        }
      }
    })
  }
}

export default Configuration



// WEBPACK FOOTER //
// ./src/library/Configuration.js